import type { IApplicationState } from '../../types/redux';
import type { INewbuildingsSummaryState } from '../../types/redux/newbuildingsSummary';

export function selectNewbuildingsSummary(state: IApplicationState): INewbuildingsSummaryState {
  return state.newbuildingsSummary;
}
